import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { resolveAuthState } from "./authApi";
import {
  getRouteFromCode,
  getAllowedRoutesForCode,
  looksLikeJwt,
  getAccessToken,
} from "./authRouting";

export default function OnboardingRoute({ children }) {
  const location = useLocation();

  const [state, setState] = useState({
    loading: true,
    redirectTo: null,
    allow: false,
  });

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      const token = getAccessToken();

      if (!looksLikeJwt(token)) {
        if (mounted) {
          setState({
            loading: false,
            redirectTo: "/sign-in",
            allow: false,
          });
        }
        return;
      }

      const forcedRoute = sessionStorage.getItem("onboarding_force_route");
      const forcedStatus = sessionStorage.getItem("onboarding_force_status");
      const storedStatus =
        forcedStatus || localStorage.getItem("user_status") || null;

      if (forcedStatus) {
        localStorage.setItem("user_status", forcedStatus);
      }

      if (forcedRoute && location.pathname === forcedRoute) {
        if (mounted) {
          setState({
            loading: false,
            redirectTo: null,
            allow: true,
          });
        }
        return;
      }

      if (forcedRoute && location.pathname !== forcedRoute) {
        if (mounted) {
          setState({
            loading: false,
            redirectTo: forcedRoute,
            allow: false,
          });
        }
        return;
      }

      const auth = await resolveAuthState();

      if (!mounted) return;

      if (!auth.isAuthenticated) {
        setState({
          loading: false,
          redirectTo: "/sign-in",
          allow: false,
        });
        return;
      }

      if (auth.onboardingStatus === "COMPLETED") {
        setState({
          loading: false,
          redirectTo: "/profile",
          allow: false,
        });
        return;
      }

      if (typeof auth.onboardingStatus === "number") {
        const correctRoute = getRouteFromCode(auth.onboardingStatus, storedStatus);
        const allowedRoutes = getAllowedRoutesForCode(
          auth.onboardingStatus,
          storedStatus
        );

        if (!correctRoute) {
          setState({
            loading: false,
            redirectTo: "/account-type-select",
            allow: false,
          });
          return;
        }

        if (allowedRoutes.includes(location.pathname)) {
          setState({
            loading: false,
            redirectTo: null,
            allow: true,
          });
          return;
        }

        setState({
          loading: false,
          redirectTo: correctRoute,
          allow: false,
        });
        return;
      }

      setState({
        loading: false,
        redirectTo: "/account-type-select",
        allow: false,
      });
    };

    run();

    return () => {
      mounted = false;
    };
  }, [location.pathname]);

  if (state.loading) {
    return <div style={{ padding: 24 }}>Loading...</div>;
  }

  if (state.redirectTo) {
    return <Navigate to={state.redirectTo} replace />;
  }

  if (state.allow) {
    return children;
  }

  return <Navigate to="/account-type-select" replace />;
}